import { isStringAllLettersOrEmpty } from 'common/helpers';
import {
  addPlusToPhoneNumber,
  normalizePhoneNumber,
  parsePhoneNumber,
} from 'features/call/call-base/helpers';
import { ANONYMOUS } from 'features/voice-meeting/constants';

/**
 * Canonical key for matching hearing phone identities.
 * Letter-only values (anonymous, blocked, Restricted) must not go through
 * keypad letter-to-digit conversion — that maps "anonymous" to 266696687.
 */
export const toHearingPhoneMatchKey = (phoneNumber: string): string => {
  const trimmed = phoneNumber.trim();
  if (!trimmed) {
    return '';
  }
  if (isStringAllLettersOrEmpty(trimmed)) {
    return ANONYMOUS;
  }
  return normalizePhoneNumber(parsePhoneNumber(trimmed));
};

export const hearingPhoneNumbersMatch = (
  left: string,
  right: string
): boolean => toHearingPhoneMatchKey(left) === toHearingPhoneMatchKey(right);

/** Dial string for Switchboard/Chime. Anonymous identities are not keypad numbers. */
export const toHearingDialString = (phoneNumber: string): string => {
  if (toHearingPhoneMatchKey(phoneNumber) === ANONYMOUS) {
    return ANONYMOUS;
  }
  return addPlusToPhoneNumber(parsePhoneNumber(phoneNumber));
};
